import { z } from 'zod';

export const activityTimelineStepStatusSchema = z.enum(['active', 'complete', 'error', 'pending']);

export type ActivityTimelineStepStatus = z.infer<typeof activityTimelineStepStatusSchema>;

export const activityTimelineStepSchema = z.object({
    detail: z.string().optional(),
    finding: z.string().optional(),
    id: z.string(),
    label: z.string(),
    status: activityTimelineStepStatusSchema,
});

export type ActivityTimelineStep = z.infer<typeof activityTimelineStepSchema>;

export const activityTimelineUsageSchema = z.object({
    credits: z.number().nonnegative().optional(),
    durationMs: z.number().nonnegative().optional(),
    tokens: z.number().int().nonnegative().optional(),
    toolCalls: z.number().int().nonnegative().optional(),
});

export type ActivityTimelineUsage = z.infer<typeof activityTimelineUsageSchema>;

export const activityTimelineBlockSchema = z.object({
    blockId: z.uuid(),
    isClosed: z.boolean().optional(),
    steps: z.array(activityTimelineStepSchema).min(1),
    title: z.string(),
    type: z.literal('activity-timeline'),
    usage: activityTimelineUsageSchema.optional(),
});

export type ActivityTimelineBlock = z.infer<typeof activityTimelineBlockSchema>;
